import { FormControlProps, MenuProps, PopoverOrigin } from '@mui/material';
import { Tag } from '../TagChip';
import { CSSProperties, JSX } from 'react';

export type Option = {
  label: string;
  secondaryLabel?: string;
  value: string | null;
  Icon?: any;
  adornments?: {
    start?: JSX.Element;
  };
  enabled?: boolean;
  tooltipText?: string;
  tag?: Tag;
};

/// PROPS
export type SelectProps = {
  open?: boolean;
  options: Option[];
  selectedOptions: Option[];
  setSelectedOptions: (options: Option[]) => void;
  isDisabled?: boolean;
  isSearchable?: boolean;
  size?: FormControlProps['size'];
  margin?: 'dense';
  disablePortal?: boolean;
  closeOnSelection?: boolean;
  label?: string;
  shrinkLabel?: boolean | null;
  isShowingLabel?: boolean;
  isWithClearSelection?: boolean;
  type?: SelectingTypes;
  onClose?: () => void;
  min?: number;
  max?: number;
  menuHeight?: number;
  menuWidth?: number;
  style?: SelectorStyles;
  popperPosition?: PopoverOrigin;
  sortFn?: ((a: Option, b: Option) => number) | null;
  filterFn?: (
    term: string,
    primaryLabel: string,
    secondaryLabel?: string,
  ) => boolean;
  menuProps?: Partial<MenuProps>;
  isBottomControls?: boolean;
  isWithCollapse?: boolean;
};

// Selecting type options
export type SelectingTypes = 'AllOrOne' | 'OnlyOne' | 'Multiple';

export type SelectorStyles = {
  [key: string]: CSSProperties;
};

export const SELECT_ITEM_HEIGHT = 58;
export const SELECT_DENSE_ITEM_HEIGHT = 42;
export const SELECT_EMPTY_ITEM_HEIGHT = 52;
export const SELECT_CONTROLLER_HEIGHT = 87;
export const SELECT_DENSE_CONTROLLER_HEIGHT = 87;
